// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__tg2KS"};